import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { listenLegalContent as listenLegalContentSingle, listenLegalContentMerged } from '../functions/firebase/legalContent';

export const useLegalContent = (pageId, options = {}) => {
  const { i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const enabled = options.enabled === undefined ? true : !!options.enabled;

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    try {
      const listenFn = pageId === 'legal' ? listenLegalContentMerged : listenLegalContentSingle;
      const unsubscribe = listenFn(pageId, (content) => {
        setData(content);
        setLoading(false);
        setError(null);
      });
      return () => unsubscribe();
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  }, [pageId, enabled]);

  const currentLangContent = data?.[i18n.language];
  const frenchContent = data?.fr;
  const fallbackToFrench = options.fallbackToFrench !== false;
  const content = fallbackToFrench ? (currentLangContent || frenchContent) : currentLangContent;

  return { data, loading, error, content, hasContent: !!content, currentLanguage: i18n.language };
};



